{
  "v2.organisation.a_venir": "écran à venir",
  "v2.organisation.annuler": "Annuler",
  "v2.organisation.appartenance.ajouter_programme": "Ajouter au programme",
  "v2.organisation.appartenance.ajouter_projet": "Ajouter au projet",
  "v2.organisation.appartenance.deja_membre": "Déjà membre : modifiez son appartenance depuis la fiche.",
  "v2.organisation.appartenance.echec": "L’appartenance n’a pas été enregistrée.",
  "v2.organisation.appartenance.enregistree": "Appartenance enregistrée.",
  "v2.organisation.appartenance.heritage_programme": "Un profil posé sur un programme vaut pour ses projets, sauf profil plus restreint posé sur un projet.",
  "v2.organisation.appartenance.heritage_projet": "Un profil plus restreint posé sur un projet l’emporte sur celui du programme ; un profil d’administration qui descend n’est jamais surchargé.",
  "v2.organisation.appartenance.modifier": "Enregistrer la modification",
  "v2.organisation.appartenance.profils_illisibles": "Les profils actuels sont illisibles : rien n’est modifiable.",
  "v2.organisation.appartenance.profils_programme": "Profils sur le programme",
  "v2.organisation.appartenance.profils_projet": "Profils sur le projet",
  "v2.organisation.appartenance.titre": "Ajouter ou modifier une appartenance",
  "v2.organisation.appartenance.type": "Type",
  "v2.organisation.aucun_profil": "Aucun profil",
  "v2.organisation.choisir": "Choisir…",
  "v2.organisation.code.ALREADY_MEMBER": "La personne est déjà membre de cet espace.",
  "v2.organisation.code.ANNUAIRE_TROP_VOLUMINEUX": "Trop de lignes : affinez les filtres.",
  "v2.organisation.code.ATTESTATION_REQUISE": "L’attestation est obligatoire.",
  "v2.organisation.code.ATTRIBUTION_REFUSEE": "Une attribution est refusée : rien n’a été envoyé.",
  "v2.organisation.code.COMPTE_DESACTIVE": "Le compte est désactivé.",
  "v2.organisation.code.CONFLIT_CONCURRENT": "La fiche a changé entre-temps : elle a été relue, vérifiez puis enregistrez de nouveau.",
  "v2.organisation.code.CORPS_HISTORIQUE_RETIRE": "Requête refusée : forme retirée.",
  "v2.organisation.code.CREATEUR_N_APPROUVE_PAS": "Le demandeur n’approuve pas sa propre demande.",
  "v2.organisation.code.DEACTIVATION_REASON_REQUIRED": "Le motif est obligatoire.",
  "v2.organisation.code.DEMANDE_DEJA_DECIDEE": "Cette demande est déjà décidée.",
  "v2.organisation.code.DEMANDE_DEJA_MEMBRE": "Cette personne est déjà membre.",
  "v2.organisation.code.DEMANDE_EN_DOUBLE": "Une demande est déjà en attente pour cette adresse.",
  "v2.organisation.code.DROIT_HORS_NIVEAU": "Ce droit n’est pas de ce niveau.",
  "v2.organisation.code.DROIT_ISOLE_INTROUVABLE": "Droit isolé introuvable.",
  "v2.organisation.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire.",
  "v2.organisation.code.DROIT_PERSONNEL_NON_ACCORDABLE": "Un droit personnel ne s’accorde pas.",
  "v2.organisation.code.DROIT_RESERVE_AU_PROPRIETAIRE": "Ce droit est réservé au propriétaire.",
  "v2.organisation.code.ECHEANCE_PASSEE": "La date doit être dans le futur.",
  "v2.organisation.code.EMAIL_NOT_SENT": "Le courriel n’est pas parti.",
  "v2.organisation.code.INVITATION_EMAIL_ALREADY_EXISTS": "Cette adresse appartient déjà à un membre ou à une invitation en cours.",
  "v2.organisation.code.INVITATION_EMAIL_DOMAIN_NOT_ALLOWED": "Le domaine de cette adresse n’est pas autorisé.",
  "v2.organisation.code.INVITATION_EMAIL_INVALID": "Adresse invalide.",
  "v2.organisation.code.INVITATION_NOT_RENEWABLE": "Cette invitation ne peut plus être renouvelée.",
  "v2.organisation.code.INVITATION_NOT_REVOCABLE": "Cette invitation est déjà acceptée ou révoquée.",
  "v2.organisation.code.INVITATION_NOT_VALID": "Cette invitation n’est plus valable.",
  "v2.organisation.code.INVITATION_RATE_LIMITED": "Trop d’invitations envoyées : réessayez plus tard.",
  "v2.organisation.code.KEYCLOAK_UNAVAILABLE": "L’annuaire de connexion est injoignable : rien n’a été modifié.",
  "v2.organisation.code.LAST_ORG_ADMIN": "Personne ne pourrait plus administrer l’organisation.",
  "v2.organisation.code.MEMBERSHIP_NOT_FOUND": "Appartenance introuvable.",
  "v2.organisation.code.MOTIF_TROP_COURT": "Le motif est trop court.",
  "v2.organisation.code.OWNERSHIP_TRANSFER_REQUIRED": "Des propriétés restent à reprendre.",
  "v2.organisation.code.PERSONNE_NON_MEMBRE": "La personne n’est pas membre de cet espace.",
  "v2.organisation.code.PROFIL_INCONNU": "Profil inconnu.",
  "v2.organisation.code.PROFIL_NIVEAU_INCOMPATIBLE": "Ce profil n’est pas de ce niveau.",
  "v2.organisation.code.PROGRAM_MEMBER_EXISTS": "La personne est déjà membre du programme.",
  "v2.organisation.code.PROPRIETAIRE_ORGANISATION_NON_DESACTIVABLE": "Le propriétaire de l’organisation ne peut pas être désactivé.",
  "v2.organisation.code.REACTIVATION_REASON_REQUIRED": "Le motif est obligatoire.",
  "v2.organisation.code.RECUPERATION_PAR_LA_PLATEFORME": "Seule la plateforme récupère l’accès du propriétaire de l’organisation.",
  "v2.organisation.code.RESTAURATION_HORS_DELAI": "Délai dépassé : les appartenances sont à réattribuer.",
  "v2.organisation.code.SELF_ACCESS_RESET_FORBIDDEN": "Vous ne réinitialisez pas votre propre accès ici.",
  "v2.organisation.code.SELF_DEACTIVATION_FORBIDDEN": "Vous ne désactivez pas votre propre compte.",
  "v2.organisation.code.SELF_ROLE_CHANGE_FORBIDDEN": "Vous ne changez pas vos propres profils.",
  "v2.organisation.code.TRANSFER_TARGET_INVALID": "Le repreneur doit être membre actif de l’espace.",
  "v2.organisation.code.USER_ALREADY_DEACTIVATED": "Le compte est déjà désactivé.",
  "v2.organisation.code.USER_DEACTIVATED": "Le compte est désactivé.",
  "v2.organisation.code.USER_NOT_DEACTIVATED": "Ce compte n’est pas désactivé.",
  "v2.organisation.code.USER_NOT_FOUND": "Membre introuvable.",
  "v2.organisation.code.WORKSPACE_ARCHIVED": "Ce projet est archivé : lecture seule.",
  "v2.organisation.demandes.adresse": "Adresse électronique de la personne",
  "v2.organisation.demandes.adresse_requise": "Indiquez l’adresse de la personne.",
  "v2.organisation.demandes.approuvee": "Demande approuvée : invitation créée.",
  "v2.organisation.demandes.approuver": "Approuver",
  "v2.organisation.demandes.approuver_de": "Approuver la demande pour {{email}}",
  "v2.organisation.demandes.approuver_echec": "La demande n’a pas été approuvée.",
  "v2.organisation.demandes.col_date": "Demandée le",
  "v2.organisation.demandes.col_demandeur": "Demandeur",
  "v2.organisation.demandes.col_motif": "Motif",
  "v2.organisation.demandes.demander": "Demander une invitation",
  "v2.organisation.demandes.echec": "La demande n’a pas été envoyée.",
  "v2.organisation.demandes.envoyee": "Demande envoyée.",
  "v2.organisation.demandes.envoyer": "Envoyer la demande",
  "v2.organisation.demandes.refusee": "Demande refusée.",
  "v2.organisation.demandes.refuser": "Refuser",
  "v2.organisation.demandes.refuser_de": "Refuser la demande pour {{email}}",
  "v2.organisation.demandes.refuser_echec": "La demande n’a pas été refusée.",
  "v2.organisation.demandes.refuser_effet": "Le demandeur est notifié du refus.",
  "v2.organisation.demandes.refuser_titre": "Refuser la demande pour {{email}} ?",
  "v2.organisation.demandes.titre": "Demandes d’invitation",
  "v2.organisation.demandes.vide": "Aucune demande en attente.",
  "v2.organisation.desactiver.ajout_echec": "Le repreneur n’a pas été ajouté.",
  "v2.organisation.desactiver.ajouter_programme": "Ajouter {{nom}} au programme",
  "v2.organisation.desactiver.ajouter_projet": "Ajouter {{nom}} au projet",
  "v2.organisation.desactiver.attestation": "J’atteste que cette personne quitte l’organisation et que les reprises sont décidées.",
  "v2.organisation.desactiver.aucun_candidat": "Aucun autre membre actif : ajoutez d’abord un repreneur à l’organisation.",
  "v2.organisation.desactiver.aucune_cle": "Aucune clé ni webhook à reprendre.",
  "v2.organisation.desactiver.aucune_reprise": "Aucune propriété à reprendre.",
  "v2.organisation.desactiver.bouton": "Désactiver le compte",
  "v2.organisation.desactiver.cles_revoquees": "Les clés et webhooks de la personne seront révoqués.",
  "v2.organisation.desactiver.consequence_appartenances": "Les appartenances aux projets et programmes sont retirées (restaurables pendant le délai).",
  "v2.organisation.desactiver.consequence_connexion": "La connexion est bloquée.",
  "v2.organisation.desactiver.consequence_historique": "L’historique est conservé.",
  "v2.organisation.desactiver.consequence_sessions": "Les sessions ouvertes sont fermées.",
  "v2.organisation.desactiver.echec": "Le compte n’a pas été désactivé.",
  "v2.organisation.desactiver.fait": "Compte désactivé.",
  "v2.organisation.desactiver.membres_espace": "les membres de {{nom}}",
  "v2.organisation.desactiver.repreneur": "Repreneur de {{nom}}",
  "v2.organisation.desactiver.repreneur_manquant": "Choisissez un repreneur.",
  "v2.organisation.desactiver.reprises": "Propriétés à reprendre",
  "v2.organisation.desactiver.titre": "Désactiver le compte d’une personne qui part",
  "v2.organisation.droit_isole.accorde": "Droit isolé accordé.",
  "v2.organisation.droit_isole.accorder": "Accorder le droit",
  "v2.organisation.droit_isole.accorder_programme": "Accorder sur le programme choisi",
  "v2.organisation.droit_isole.accorder_projet": "Accorder sur le projet choisi",
  "v2.organisation.droit_isole.case_prerequis": "Accorder aussi les prérequis de lecture",
  "v2.organisation.droit_isole.case_publier": "Accorder aussi le droit de publier",
  "v2.organisation.droit_isole.catalogue_erreur": "Le catalogue des droits est illisible.",
  "v2.organisation.droit_isole.choisir_droit": "Choisir un droit",
  "v2.organisation.droit_isole.date": "Date de fin (facultative)",
  "v2.organisation.droit_isole.date_future": "La date doit être dans le futur.",
  "v2.organisation.droit_isole.deja_tenu": "Déjà tenu par un profil : ce droit isolé est inutile.",
  "v2.organisation.droit_isole.droit": "Droit",
  "v2.organisation.droit_isole.ecart": "Ce droit sera affiché comme un écart dans l’administration de l’organisation ; la séparation des tâches reste au-dessus.",
  "v2.organisation.droit_isole.echec": "Le droit n’a pas été accordé.",
  "v2.organisation.droit_isole.inutilisable": "Sans eux, le droit restera inutilisable.",
  "v2.organisation.droit_isole.l_organisation": "L’organisation",
  "v2.organisation.droit_isole.objet": "Objet visé",
  "v2.organisation.droit_isole.prerequis": "Prérequis de lecture : {{liste}}",
  "v2.organisation.droit_isole.prerequis_aucun": "Aucun prérequis de lecture manquant.",
  "v2.organisation.droit_isole.prolonger": "Déjà accordé en droit isolé : la date de fin sera prolongée.",
  "v2.organisation.droit_isole.titre": "Accorder un droit isolé à une personne",
  "v2.organisation.droit_isole.un_programme": "Un programme",
  "v2.organisation.droit_isole.un_projet": "Un projet",
  "v2.organisation.empeche.deja_desactive": "Le compte est déjà désactivé.",
  "v2.organisation.empeche.desactive": "Le compte est désactivé.",
  "v2.organisation.empeche.pas_desactive": "Ce compte n’est pas désactivé.",
  "v2.organisation.empeche.proprietaire_acces": "Le propriétaire de l’organisation est récupéré par la plateforme seule.",
  "v2.organisation.empeche.proprietaire_depart": "Le propriétaire de l’organisation ne part qu’après avoir transféré la propriété.",
  "v2.organisation.empeche.vous": "C’est votre propre compte.",
  "v2.organisation.enregistrer": "Enregistrer",
  "v2.organisation.etat.chargement": "Chargement : {{quoi}}…",
  "v2.organisation.etat.en_cours": "En cours…",
  "v2.organisation.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v2.organisation.etat.introuvable": "{{quoi}} introuvable.",
  "v2.organisation.etat.reessayer": "Réessayer",
  "v2.organisation.etat.refus": "Accès refusé : {{quoi}}.",
  "v2.organisation.fermer": "Fermer",
  "v2.organisation.fiche.acces_et_depart": "Accès et départ",
  "v2.organisation.fiche.accorder": "Accorder un droit isolé",
  "v2.organisation.fiche.actions_requises": "Actions requises : {{liste}}",
  "v2.organisation.fiche.ajouter_appartenance": "Ajouter une appartenance",
  "v2.organisation.fiche.annuaire_injoignable": "Annuaire de connexion injoignable : état du compte inconnu.",
  "v2.organisation.fiche.appartenance": "{{nom}} ({{niveau}})",
  "v2.organisation.fiche.appartenances": "Appartenances",
  "v2.organisation.fiche.attribuer": "Attribuer un profil",
  "v2.organisation.fiche.aucun_droit": "Aucun droit effectif.",
  "v2.organisation.fiche.aucun_historique": "Aucun événement.",
  "v2.organisation.fiche.aucun_isole": "Aucun droit isolé.",
  "v2.organisation.fiche.aucun_profil_pose": "Aucun profil d’organisation posé.",
  "v2.organisation.fiche.aucune_appartenance": "Aucune appartenance à un projet ou un programme.",
  "v2.organisation.fiche.aucune_delegation": "Aucune délégation.",
  "v2.organisation.fiche.aucune_invitation": "Aucune invitation ni lien.",
  "v2.organisation.fiche.avec_delegation": "Tient aussi des droits par une délégation reçue.",
  "v2.organisation.fiche.compte": "Compte de connexion",
  "v2.organisation.fiche.connexion_autorisee": "Connexion autorisée",
  "v2.organisation.fiche.connexion_bloquee": "Connexion bloquée",
  "v2.organisation.fiche.deconnectee": "Sessions fermées : la personne est déconnectée partout.",
  "v2.organisation.fiche.deconnecter": "Forcer la déconnexion",
  "v2.organisation.fiche.deconnecter_echec": "Les sessions n’ont pas été fermées.",
  "v2.organisation.fiche.deconnecter_effet": "La personne est déconnectée partout ; ses jetons antérieurs sont refusés.",
  "v2.organisation.fiche.deconnecter_titre": "Forcer la déconnexion de {{nom}} ?",
  "v2.organisation.fiche.delegation_donnees": "Délégation donnée, jusqu’au {{fin}}",
  "v2.organisation.fiche.delegation_recues": "Délégation reçue, jusqu’au {{fin}}",
  "v2.organisation.fiche.delegations": "Délégations",
  "v2.organisation.fiche.dernier_acces": "Dernier accès : {{date}}",
  "v2.organisation.fiche.dernier_proprietaire": "dernier propriétaire actif",
  "v2.organisation.fiche.droits": "Droits effectifs",
  "v2.organisation.fiche.droits_sur": "{{objet}} : {{n}} droits effectifs ({{profils}})",
  "v2.organisation.fiche.historique": "Historique du membre",
  "v2.organisation.fiche.identifiant": "Identifiant technique",
  "v2.organisation.fiche.invitation_ligne": "{{statut}} — {{date}}",
  "v2.organisation.fiche.invitations": "Invitations et liens",
  "v2.organisation.fiche.isole_echec": "Le droit isolé n’a pas été retiré.",
  "v2.organisation.fiche.isole_ligne": "{{droit}} — sur {{objet}}, {{fin}}",
  "v2.organisation.fiche.isole_retire": "Droit isolé retiré.",
  "v2.organisation.fiche.isoles": "Droits isolés",
  "v2.organisation.fiche.isoles_signales": "{{n}} droit(s) isolé(s)",
  "v2.organisation.fiche.libelle": "Fiche du membre",
  "v2.organisation.fiche.modifier_appartenance": "Modifier l’appartenance à {{nom}}",
  "v2.organisation.fiche.otp_a_configurer": "Second facteur à configurer",
  "v2.organisation.fiche.otp_configure": "Second facteur configuré",
  "v2.organisation.fiche.otp_non_configure": "Second facteur non configuré",
  "v2.organisation.fiche.par_propriete": "Administré par la propriété.",
  "v2.organisation.fiche.phrase": "{{date}} — {{acteur}} : {{action}}",
  "v2.organisation.fiche.profil_origine": "{{profil}} (posé sur : {{origine}})",
  "v2.organisation.fiche.profils": "Profils et droits",
  "v2.organisation.fiche.reinitialiser": "Réinitialiser l’accès",
  "v2.organisation.fiche.restreint": "restreint par {{liste}}",
  "v2.organisation.fiche.retirer_isole": "Retirer le droit isolé {{droit}}",
  "v2.organisation.fiche.retirer_isole_effet": "Le droit cesse aussitôt ; il reste dans l’historique.",
  "v2.organisation.fiche.retirer_isole_titre": "Retirer le droit isolé « {{droit}} » ?",
  "v2.organisation.fiche.retour": "Retour aux membres",
  "v2.organisation.fiche.sans_fin": "sans date de fin",
  "v2.organisation.fiche.titre": "Fiche d’un membre",
  "v2.organisation.fiche.tout_le_journal": "Tout son journal",
  "v2.organisation.fiche.transferer": "Transférer la propriété à ce membre",
  "v2.organisation.fiche.voir_profil": "Voir le profil",
  "v2.organisation.fiche.vous": "c’est vous",
  "v2.organisation.invitation.statut.accepted": "Acceptée",
  "v2.organisation.invitation.statut.expired": "Expirée",
  "v2.organisation.invitation.statut.pending": "En attente",
  "v2.organisation.invitation.statut.revoked": "Révoquée",
  "v2.organisation.invitations.col_actions": "Actions",
  "v2.organisation.invitations.col_adresse": "Adresse",
  "v2.organisation.invitations.col_expire": "Expire le",
  "v2.organisation.invitations.col_statut": "Statut",
  "v2.organisation.invitations.filtre": "Statut des invitations",
  "v2.organisation.invitations.inviter": "Inviter une personne",
  "v2.organisation.invitations.lien_pour": "Nouveau lien pour {{email}} : transmettez-le vous-même.",
  "v2.organisation.invitations.renouvelee": "Invitation renouvelée : nouveau lien, l’ancien est révoqué.",
  "v2.organisation.invitations.renouveler": "Renouveler",
  "v2.organisation.invitations.renouveler_de": "Renouveler l’invitation de {{email}}",
  "v2.organisation.invitations.renouveler_echec": "L’invitation n’a pas été renouvelée.",
  "v2.organisation.invitations.revoquee": "Invitation révoquée.",
  "v2.organisation.invitations.revoquer": "Révoquer",
  "v2.organisation.invitations.revoquer_de": "Révoquer l’invitation de {{email}}",
  "v2.organisation.invitations.revoquer_echec": "L’invitation n’a pas été révoquée.",
  "v2.organisation.invitations.revoquer_effet": "Le lien cesse de fonctionner ; un compte jamais activé est supprimé.",
  "v2.organisation.invitations.revoquer_titre": "Révoquer l’invitation de {{email}} ?",
  "v2.organisation.invitations.sans_courriel": "Installation sans envoi de courriel : vous transmettrez le lien vous-même.",
  "v2.organisation.invitations.titre": "Invitations",
  "v2.organisation.invitations.toutes": "Toutes",
  "v2.organisation.invitations.vide": "Aucune invitation.",
  "v2.organisation.inviter.adresse": "Adresse électronique",
  "v2.organisation.inviter.adresse_invalide": "Adresse invalide.",
  "v2.organisation.inviter.ajouter_attribution": "Ajouter l’attribution",
  "v2.organisation.inviter.attribution": "{{espace}} — {{profil}}",
  "v2.organisation.inviter.attributions": "Attributions sur des projets et programmes",
  "v2.organisation.inviter.aucune_attribution": "Aucune attribution.",
  "v2.organisation.inviter.avertissement_admin": "Ce profil donne l’administration de toute l’organisation.",
  "v2.organisation.inviter.bouton": "Inviter",
  "v2.organisation.inviter.courriel_non_parti": "Le courriel n’est pas parti : copiez le lien et transmettez-le vous-même.",
  "v2.organisation.inviter.doublon": "Doublon de soumission ignoré : l’invitation existe déjà.",
  "v2.organisation.inviter.echec": "L’invitation n’a pas été envoyée.",
  "v2.organisation.inviter.espace": "Espace de l’attribution",
  "v2.organisation.inviter.espaces": "les projets et programmes",
  "v2.organisation.inviter.membre_simple": "Aucun (membre simple)",
  "v2.organisation.inviter.nom": "Nom",
  "v2.organisation.inviter.prenom": "Prénom",
  "v2.organisation.inviter.profil_organisation": "Profil d’organisation",
  "v2.organisation.inviter.profil_programme": "Profil sur le programme",
  "v2.organisation.inviter.profil_projet": "Profil sur le projet",
  "v2.organisation.inviter.renvoi_echec": "Le courriel n’a pas été renvoyé.",
  "v2.organisation.inviter.renvoi_non_parti": "Le courriel n’est toujours pas parti.",
  "v2.organisation.inviter.renvoye": "Courriel renvoyé.",
  "v2.organisation.inviter.renvoyer": "Renvoyer le courriel",
  "v2.organisation.inviter.retirer_attribution": "Retirer l’attribution sur {{espace}}",
  "v2.organisation.inviter.titre": "Inviter une personne dans l’organisation",
  "v2.organisation.inviter.validite": "Validité du lien",
  "v2.organisation.inviter.validite_168": "7 jours",
  "v2.organisation.inviter.validite_24": "24 heures",
  "v2.organisation.inviter.validite_72": "3 jours",
  "v2.organisation.jamais": "Jamais",
  "v2.organisation.lien.copie": "Lien copié.",
  "v2.organisation.lien.copier": "Copier le lien",
  "v2.organisation.lien.une_fois": "Lien à transmettre vous-même : il n’est affiché qu’une seule fois.",
  "v2.organisation.membres.aucun_profil": "Aucun profil d’organisation",
  "v2.organisation.membres.aucun_resultat": "Aucun membre ne correspond aux filtres.",
  "v2.organisation.membres.col_acces": "Dernier accès",
  "v2.organisation.membres.col_espaces": "Projets et programmes",
  "v2.organisation.membres.col_nom": "Nom",
  "v2.organisation.membres.col_profils": "Profils posés",
  "v2.organisation.membres.col_proprietaire": "Propriétaire",
  "v2.organisation.membres.col_second": "Second facteur",
  "v2.organisation.membres.col_statut": "Statut",
  "v2.organisation.membres.compte_actifs": "Actifs : {{n}}",
  "v2.organisation.membres.compte_admins": "Administrateurs : {{n}}",
  "v2.organisation.membres.compte_desactives": "Désactivés : {{n}}",
  "v2.organisation.membres.compte_invites": "Invités : {{n}}",
  "v2.organisation.membres.compteurs_chargement": "Chargement des compteurs…",
  "v2.organisation.membres.compteurs_erreur": "Compteurs indisponibles.",
  "v2.organisation.membres.effacer": "Effacer les filtres",
  "v2.organisation.membres.espaces": "{{projets}} projet(s), {{programmes}} programme(s)",
  "v2.organisation.membres.export_echec": "L’annuaire n’a pas été exporté.",
  "v2.organisation.membres.export_filtres": "Selon les filtres appliqués.",
  "v2.organisation.membres.exporte": "Annuaire exporté (écrit au journal).",
  "v2.organisation.membres.exporter": "Exporter l’annuaire",
  "v2.organisation.membres.filtre_espace": "Projet ou programme",
  "v2.organisation.membres.filtre_profil": "Profil",
  "v2.organisation.membres.filtre_second": "Second facteur",
  "v2.organisation.membres.filtre_statut": "Statut",
  "v2.organisation.membres.lecture_seule": "Lecture seule : vous ne gérez pas les membres.",
  "v2.organisation.membres.libelle": "Annuaire",
  "v2.organisation.membres.libelle_table": "Membres",
  "v2.organisation.membres.onglet_membres": "Membres",
  "v2.organisation.membres.onglet_profils": "Profils",
  "v2.organisation.membres.onglet_revue": "Revue des refus",
  "v2.organisation.membres.onglet_securite": "Sécurité de connexion",
  "v2.organisation.membres.onglets": "Sections des membres",
  "v2.organisation.membres.page": "{{de}} à {{a}} sur {{total}}",
  "v2.organisation.membres.precedente": "Page précédente",
  "v2.organisation.membres.proprietaire": "Propriétaire",
  "v2.organisation.membres.rechercher": "Rechercher",
  "v2.organisation.membres.second_a_configurer": "À configurer",
  "v2.organisation.membres.second_configure": "Configuré",
  "v2.organisation.membres.second_non_configure": "Non configuré",
  "v2.organisation.membres.statut_active": "Actif",
  "v2.organisation.membres.statut_deactivated": "Désactivé",
  "v2.organisation.membres.statut_invited": "Invité",
  "v2.organisation.membres.suivante": "Page suivante",
  "v2.organisation.membres.titre": "Membres de l’organisation",
  "v2.organisation.membres.vide": "Aucun membre.",
  "v2.organisation.modifier": "Modifier",
  "v2.organisation.motif": "Motif",
  "v2.organisation.motif_facultatif": "Motif (facultatif)",
  "v2.organisation.motif_min": "{{n}} caractères au moins.",
  "v2.organisation.niveau.organisation": "organisation",
  "v2.organisation.niveau.programme": "programme",
  "v2.organisation.niveau.projet": "projet",
  "v2.organisation.niveau_titre.programme": "Programme",
  "v2.organisation.niveau_titre.projet": "Projet",
  "v2.organisation.pour": "Personne concernée : {{nom}}",
  "v2.organisation.profils.champ": "Profils d’organisation (cumul possible)",
  "v2.organisation.profils.dernier_admin": "Retrait refusé : personne ne pourrait plus administrer l’organisation.",
  "v2.organisation.profils.echec": "Les profils n’ont pas été enregistrés.",
  "v2.organisation.profils.enregistres": "Profils d’organisation enregistrés.",
  "v2.organisation.profils.membre_simple": "Aucun profil coché : membre simple, sans droit d’organisation.",
  "v2.organisation.profils.pour": "Profils d’organisation de {{nom}}",
  "v2.organisation.profils.titre": "Attribuer ou retirer un profil d’organisation",
  "v2.organisation.reactiver.au_dela": "Délai dépassé : rien ne sera restauré, les appartenances sont à réattribuer.",
  "v2.organisation.reactiver.aucune": "Aucune appartenance retirée à restaurer.",
  "v2.organisation.reactiver.bouton": "Réactiver le compte",
  "v2.organisation.reactiver.echec": "Le compte n’a pas été réactivé.",
  "v2.organisation.reactiver.effet_appartenances": "Les appartenances retirées ne reviennent que si vous les restaurez pendant le délai.",
  "v2.organisation.reactiver.effet_connexion": "La personne pourra de nouveau se connecter.",
  "v2.organisation.reactiver.fait": "Compte réactivé.",
  "v2.organisation.reactiver.item": "{{nom}} ({{niveau}}) : {{profils}}",
  "v2.organisation.reactiver.restaurer": "Restaurer ses appartenances retirées (délai jusqu’au {{date}})",
  "v2.organisation.reactiver.retirees": "Appartenances retirées",
  "v2.organisation.reactiver.titre": "Réactiver un compte désactivé",
  "v2.organisation.reinit.bouton": "Réinitialiser l’accès",
  "v2.organisation.reinit.courriel": "Un courriel a été envoyé à la personne.",
  "v2.organisation.reinit.echec": "L’accès n’a pas été réinitialisé.",
  "v2.organisation.reinit.effet_journal": "La personne est notifiée et le geste est écrit au journal.",
  "v2.organisation.reinit.effet_lien": "Un lien à usage unique, valable 24 heures, permet de choisir un nouveau mot de passe.",
  "v2.organisation.reinit.effet_mot_de_passe": "Le mot de passe actuel reste valable jusqu’à l’usage du lien.",
  "v2.organisation.reinit.effet_sessions": "Les sessions ouvertes sont fermées à l’usage du lien.",
  "v2.organisation.reinit.otp": "Réinitialiser aussi le second facteur",
  "v2.organisation.reinit.otp_effet": "Le second facteur est supprimé maintenant et sera à reconfigurer.",
  "v2.organisation.reinit.titre": "Réinitialiser l’accès d’un membre",
  "v2.organisation.retirer": "Retirer",
  "v2.organisation.sans_organisation": "Votre compte n’est rattaché à aucune organisation.",
  "v2.organisation.simulation.aucun": "Aucun droit ne change.",
  "v2.organisation.simulation.calcul": "Calcul des droits qui changent…",
  "v2.organisation.simulation.erreur": "Les droits qui changent n’ont pas pu être calculés.",
  "v2.organisation.simulation.gagnes": "Droits gagnés :",
  "v2.organisation.simulation.perdus": "Droits perdus :",
  "v2.organisation.simulation.titre": "Droits qui changent",
  "v2.organisation.statut.actif": "Actif",
  "v2.organisation.statut.desactive_le": "Désactivé le {{date}}",
  "v2.organisation.statut.invite": "Invité, activation en attente",
  "v2.organisation.tous": "Tous",
  "v2.organisation.voir": "Voir"
}
